export default "__VITE_ASSET__Ccn5eSYQ__"